.resend {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wait {
  display: flex;
  align-items: center;
  min-height: 44px;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
}

.button {
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.notice {
  font-size: 14px;
  color: var(--ink-2);
}
